import { TableSortOption } from '@evinced-private/ui-common';

import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';

import { GetAllIssuesQuery } from '../queries/all-issues/AllIssues.generated';
import { GetAllIssues } from '../queries/all-issues/AllIssues.gql';
import { buildAllIssuesVariables } from '../queries/all-issues/helpers/buildVariables';
import {
	IAllIssuesResult,
	transformAllIssuesResults
} from '../queries/all-issues/helpers/transformResults';

export const getAllIssues = async (
	filters: IFilterOptions,
	page: number,
	sizePerPage: number,
	sort?: TableSortOption
): Promise<IAllIssuesResult> => {
	try {
		const variables = buildAllIssuesVariables(filters, page, sizePerPage, sort);

		const result = await gqlClient.request<GetAllIssuesQuery>(GetAllIssues, variables);

		return transformAllIssuesResults(result);
	} catch (e) {
		Logger.error('AllIssuesService -> getAllIssues failed:', e);
		throw e;
	}
};
